export const datetimeFormat = {
  YYYYMMDDdddJp: 'YYYY年MM月DD日(ddd)',
};
